const unsplash = (id, w = 1800) =>
    `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

export const SECTORS_INTRO = {
    eyebrow: "BUILDEASE | BUILDING SECTORS",
    copy: "BuildEase is designed to bring greater clarity, cost intelligence and informed decision-making to the built environment. Our initial focus is residential construction, with opportunities to expand into commercial, industrial and institutional building sectors over time.",
};

export const SECTORS = [
    {
        id: "residential",
        n: "01",
        title: "Residential Buildings",
        status: "CORE MARKET",
        tier: "core",
        copy: "Our primary focus is residential construction, initially supporting homeowners and property owners with residential projects under 500 m². BuildEase is designed to simplify construction information, improve cost visibility and support more informed building decisions.",
        image: unsplash("photo-1613490493576-7fde63acd811", 2200),
        alt: "Contemporary double-storey home with timber soffits, large glazing and a pool at its patio",
        caption: "PRIMARY FOCUS — PROJECTS UNDER 500 M²",
        types: [
            "Detached family homes",
            "Luxury homes and villas",
            "Townhouses",
            "Duplexes",
            "Residential apartments",
            "Holiday homes",
            "Rental properties",
            "Secondary dwellings and granny flats",
            "Residential extensions and renovations",
            "Small multi-unit residential developments",
        ],
    },
    {
        id: "commercial",
        n: "02",
        title: "Commercial Buildings",
        status: "FUTURE EXPANSION",
        tier: "future",
        copy: "BuildEase sees an opportunity to extend its construction intelligence capabilities into commercial property projects, supporting greater visibility across development, renovation and property improvement decisions.",
        image:
            "https://images.unsplash.com/photo-1776486678764-525329086a36?q=80&w=1800&auto=format&fit=crop&ar=16:9&crop=entropy",
        alt: "Modern shopping mall exterior at dusk with an illuminated walkway and geometric glass facades",
        caption: "FUTURE HORIZON — COMMERCIAL & MIXED-USE",
        types: [
            "Office buildings",
            "Retail shops and shopping centres",
            "Restaurants and cafés",
            "Small hotels and guesthouses",
            "Warehouses",
            "Storage facilities",
            "Mixed-use buildings combining retail and residential spaces",
            "Commercial fit-outs and renovations",
        ],
    },
    {
        id: "industrial",
        n: "03",
        title: "Industrial Buildings",
        status: "LATER-STAGE OPPORTUNITY",
        tier: "later",
        copy: "Industrial construction represents a potential later-stage opportunity for BuildEase, extending the platform's long-term vision into industrial development, logistics infrastructure and specialised building projects.",
        image: unsplash("photo-1557761469-f29c6e201784", 2200),
        alt: "Long white warehouse facade with a rhythmic row of loading doors under soft light",
        caption: "LONGER HORIZON — LOGISTICS & INDUSTRY",
        types: [
            "Industrial warehouses",
            "Distribution centres",
            "Manufacturing facilities",
            "Workshops",
            "Light-industrial buildings",
            "Storage and logistics facilities",
        ],
    },
    {
        id: "institutional",
        n: "04",
        title: "Institutional & Community Buildings",
        status: "LONG-TERM OPPORTUNITY",
        tier: "longterm",
        copy: "Over the longer term, BuildEase aims to explore opportunities across institutional and community infrastructure, supporting the development and improvement of buildings that serve essential public and community needs.",
        image: unsplash("photo-1741638511355-7b0037a52f2d", 1800),
        alt: "Contemporary educational building exterior with glass curtain walls and warm timber canopies",
        caption: "LONG-TERM VISION — COMMUNITY & PUBLIC",
        types: [
            "Schools and educational facilities",
            "Childcare centres",
            "Community halls",
            "Healthcare clinics",
            "Places of assembly",
            "Religious buildings",
            "Other community facilities",
        ],
    },
];

export const SECTORS_CLOSING = {
    headingA: "Starting with homes.",
    headingB: "Building intelligence for the wider built environment.",
    copy: "BuildEase remains committed to South African residential construction first — expansion into further sectors will be considered only once that foundation is proven.",
};
